import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { AutoCompleteField } from "./form-components/AutoCompleteField";

interface CloneDialogProps {
  isOpen: boolean;
  data: any;
  selectedFlow: any;
  handleClose: (isSubmitted: boolean) => void;
  handleChangeFlow: (selectedFlow: any) => void;
}

const CloneDialog: React.FC<CloneDialogProps> = ({
  isOpen,
  data,
  selectedFlow,
  handleClose,
  handleChangeFlow
}) => {

  const handleChange = (value: any) => {
    handleChangeFlow(value);
  };

  const handleCancel = (isSubmit: boolean) => {
    handleClose(isSubmit);
  };

  return (
    <Dialog open={isOpen} aria-describedby="clone-dialog">
      <DialogTitle>Clone</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ marginBottom: 2 }}>
          To clone a flow, please select any flow here. We will clone it.
        </DialogContentText>
        <AutoCompleteField
          label="Flows"
          fullWidth={true}
          itemsList={data}
          handleOnChange={handleChange}
          value={selectedFlow}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => handleCancel(false)}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={!selectedFlow}
          onClick={() => handleCancel(true)}
        >
          Clone
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CloneDialog;
